import { combineReducers } from 'redux'
import * as auth from './auth/reducers'
import * as apiCall from './apiCall/reducers'
import * as modal from './modal/reducers'
import * as ui from './ui/reducers'
import themeReducer from './theme/reducers'

const rootReducer = combineReducers({
  theme: themeReducer,
  auth: auth.reducer,
  apiCall: apiCall.reducer,
  modal: modal.reducer,
  ui: ui.reducer
})

export default rootReducer
